module.exports = __webpack_public_path__ + "img/prescription-photo-icon.24244583.webp";